import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

interface RunConfigRequestData {
  pipeline_type: string;
  intent_id: string;
  config: Record<string, any>;
  upstream_linked_run_id: string | null;
  downstream_linked_run_id: string | null;
}

export type RunConfigRequest = RunConfigRequestData | RunConfigRequestData[];

/**
 * runs a single configuration pipeline
 */
const runSingleConfig = async (request: RunConfigRequestData) => {
  const response = await axios.post('/run_config', request);
  return response.data;
};

/**
 * runs multiple configuration pipelines
 */
const runMultipleConfigs = async (requests: RunConfigRequestData[]) => {
  const runConfigPromises = requests.map((request) => runSingleConfig(request));
  return Promise.all(runConfigPromises);
};

/**
 * runs configuration pipeline(s) based on the input
 */
const triggerRunConfig = async (data: RunConfigRequest) => {
  if (Array.isArray(data)) {
    return runMultipleConfigs(data);
  }
  return runSingleConfig(data);
};

/**
 * React Query hook for running the configuration pipeline
 */
export function useTriggerRun() {
  const { mutate } = useMutation({
    mutationFn: triggerRunConfig,
  });

  return { triggerRun: mutate };
}
